import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    PERFIL_ADMIN,
    getAdminEmpresa,
    getGestorEmpresa,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import buscarAdesaoPontoPorEmpresa from '../../actions/adesao-pontos/buscarAdesaoPontoPorEmpresa';
import buscarClientesPorEmpresa from '../../actions/adesao-pontos/buscarClientesEmpresa';

export class MenuAdesaoPontosEmpresa extends Component {

    render() {
        const emp = this.props.empresaSelecionada;
        return (
            <div className="container-padrao">
                <Titulo texto="Adesão de Pontos" urlRetorno="/gestao-empresa" />
                <Autorizacao perfisPermitidos={[
                    PERFIL_ADMIN,
                    getGestorEmpresa(emp.id),
                    getAdminEmpresa(emp.id),
                ]}>
                    <div className="vx-menu-grid">
                        <Link
                            to="/painel-cadastro-configuracao-consumo-ponto"
                            onClick={() => this.props.buscarAdesaoPontoPorEmpresa(emp.id)}
                            className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">stars</i>
                            </div>
                            <span className="vx-menu-card-label">Configuração de Pontos</span>
                        </Link>
                        <Link
                            to="/painel-gerenciar-clientes-empresa"
                            onClick={() => this.props.buscarClientesPorEmpresa(emp.id)}
                            className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">people</i>
                            </div>
                            <span className="vx-menu-card-label">Lista de Clientes</span>
                        </Link>
                    </div>
                </Autorizacao>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication,
    };
}

export default withRouter(connect(mapStateToProps, {
    buscarAdesaoPontoPorEmpresa,
    buscarClientesPorEmpresa,
})(MenuAdesaoPontosEmpresa));
